import React from 'react';

import { isHistoricalSubject } from 'venn-utils';
import { isReportState, type StudioRequestSubject } from 'venn-state';
import { ItemType } from 'venn-ui-kit';

import { Block } from '../../core';
import { useRecoilValue } from 'recoil';
import { HistoricalPortfolioStudioHeaderTooltips } from '../historical-portfolio/HistoricalPortfolioStudioHeaderTooltips';
import { Name } from '../legend';

interface IndividualBenchmarkProps {
  id: string;
  benchmark: StudioRequestSubject;
}

export const IndividualBenchmark = ({ id, benchmark: individualBenchmark }: IndividualBenchmarkProps) => {
  const isStudio = !useRecoilValue(isReportState);

  return (
    <>
      <Block.SubjectsItem iconType={ItemType.CommonBenchmark}>
        <Name id={id} subject={individualBenchmark} isBenchmark />
      </Block.SubjectsItem>
      {isHistoricalSubject(individualBenchmark) && isStudio && (
        <HistoricalPortfolioStudioHeaderTooltips blockId={id} subject={individualBenchmark} isBenchmark />
      )}
    </>
  );
};
